import smoothscroll from 'smoothscroll-polyfill';

require('./interactive-section');
require('./investor-relations-reports-tabs');
require('./carriers-slider');
require('./sliders');
require('./interactive-scroll');
require('./products-filter.js');

import { setSliderHeight } from './common';

smoothscroll.polyfill();

$(function handleTabsWithTiles() {
    if (!$('.tabs-with-tiles').length) {
        return;
    }

    const navList = $('.tabs-with-tiles li');

    navList.click(function() {
        const selectedIndex = $(this).index();

        navList.each((index, anchor) => {
            $(anchor).removeClass('active');
            if (selectedIndex === index) {
                $(anchor).addClass('active');
            }
        });

        $('.tiles-wrapper').each((index, anchor) => {
            $(anchor).removeClass('active');
            if (selectedIndex === index) {
                $(anchor).addClass('active');
            }
        });
    });
});

$(function handleNavbar() {
    const nav = document.querySelector('.navbar-holder');
    const navHeight = $(nav).height();
    const windowHeight = $(window).height();

    const headroom = new Headroom(nav, {
        onPin: () => $(nav).trigger('navChanged'),
        onUnpin: () => $(nav).trigger('navChanged'),
    });

    headroom.init();

    if (!$('.homepage-hero-module').length) {
        return;
    }

    $(window).on('scroll', () => {
        setNavbarClasses($(this).scrollTop());
    });

    $('.navbar-toggler').click(e => {
        if (
            $(e.target)
                .closest('button')
                .hasClass('collapsed')
        ) {
            $('.navbar-holder').addClass('navbar-holder-expanded');
            $('body').addClass('mobile-menu-expanded');

            // $(nav).addClass('navbar-white');
        } else {
            $('.navbar-holder').removeClass('navbar-holder-expanded');
            $('body').removeClass('mobile-menu-expanded');
        }

        setNavbarClasses($(this).scrollTop());
    });

    function setNavbarClasses(scrollTop) {
        $(nav).removeClass('navbar-holder-overlay');

        if (scrollTop > 0) {
            $(nav).addClass('navbar-holder-overlay');
        }

        if (scrollTop < windowHeight - navHeight && !$('#navbarContent').hasClass('show')) {
            // $(nav).removeClass('navbar-white');
            return;
        }

        // $(nav).addClass('navbar-white');
    }

    setNavbarClasses($(window).scrollTop());
});

$(function handleSVGImages() {
    $('figure img').each((_index, img) => {
        const $img = $(img);
        const imgID = $img.attr('id');
        const imgClass = $img.attr('class');
        const imgURL = $img.attr('src');

        $.get(
            imgURL,
            data => {
                let $svg = $(data).find('svg');

                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }

                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                $svg = $svg.removeAttr('xmlns:a');

                const height = $img.attr('height');
                const width = $img.attr('width');

                if (!$svg.attr('viewBox') && height && width) {
                    $svg.attr('viewBox', '0 0 ' + height + ' ' + width);
                }

                $img.closest('figure')
                    .width(width)
                    .height(height);

                $img.replaceWith($svg);
            },
            'xml',
        );
    });
});

$(function handleScrollDownButton() {
    $('.button-scroll-down').click(function(e) {
        $('html, body').animate(
            {
                scrollTop: $('.container-fluid:eq(2)').offset().top,
            },
            800,
        );
        e.preventDefault();
    });
});

$(function handleTabs() {
    if (!!$('.section-slider').length || !!$('.section-carriers-slider').length || !!$('.section-grid-slider').length) {
        return;
    }

    $('.tab-content')
        .find('.tab-pane:first')
        .addClass('active');

    const tabs = $('.tabs');

    tabs.find('.nav-tabs a[role*="tab"]:first').addClass('active');

    setSliderHeight();

    $('.nav-tabs a[role*="tab"]').click(function(e) {
        const tab = $(this).closest('.tabs');
        const index = $(this)
            .closest('li')
            .index();

        let prevIndex;
        $.each(tab.find('a[role*="tab"]'), (index, anchor) => {
            if ($(anchor).hasClass('active')) {
                prevIndex = index;
            }
        });

        if (index === prevIndex) {
            return;
        }

        tab.find('a[role*="tab"]').removeClass('active');
        $(this).addClass('active');

        const $newSlide = tab.find(`.tab-pane:eq(${index})`);
        const $prevSlide = tab.find(`.tab-pane:eq(${prevIndex})`);

        $prevSlide.animate(
            {
                marginTop: index > prevIndex ? -$prevSlide.height() : $prevSlide.height(),
            },
            300,
            () => $prevSlide.removeClass('active'),
        );

        $newSlide.addClass('active').animate(
            {
                marginTop: 0,
            },
            300,
        );

        e.preventDefault();
    });
});

$(function prepareBlogAdvertisements() {
    const $placeholder = $('.blog-advertisement-placeholder');

    if ($('.blog-empty').length || !$placeholder.length) {
        return;
    }

    $placeholder.append($('.section-blog-advertisement'));
    $('.section-blog-advertisement').show();
});

$(function handleBlogLoadMore() {
    $('.load-more').click(function(e) {
        $('.post-hidden:lt(9)')
            .slideDown('fast')
            .removeClass('post-hidden')
            .css('display', 'flex');

        if (!$('.post-hidden').length) {
            $('.load-more').fadeOut();
        }

        e.preventDefault();
    });
});

$(function handleFilledInputs() {
    $('.textinput, .emailinput').change(function(e) {
        $(this).toggleClass('filled');
    });
});

$(function setCurrentYear() {
    $('.current-year').html(new Date().getFullYear());
});

$(function handleFixedButtonsSection() {
    if (!$('.section-post-detail').length) {
        return;
    }

    setScroll();

    $(document).scroll(setScroll);

    function setScroll() {
        const scrollTop = $(document).scrollTop();
        const section = $('.fixed-section');
        const endPos = $('.post-detail .h-line').offset().top;
        const sidebarOffset = $('.post-sidebar').offset().top;
        const sidebarTop = 200;

        if (scrollTop > sidebarOffset - sidebarTop) {
            if (scrollTop > endPos - section.height() - sidebarTop) {
                section.removeClass('fixed').addClass('stick-bottom');
            } else {
                section.addClass('fixed').removeClass('stick-bottom');
            }
        } else {
            section.removeClass('fixed');
        }
    }
});

$('#mc-embedded-subscribe-form-home-newsletter').submit(function(e) {
    e.preventDefault();

    $('.recaptcha').removeClass('error');

    if (!reCaptchaChecked && !DEBUG) {
        $('.recaptcha').addClass('error');

        return;
    }

    const feedbackBox = $(this).find('.alert');
    const $resourceLink = $('.resource-link');

    const isAlreadySubscribed = message => {
        return /is already subscribed/.test(message);
    };

    const hasTooManySignupRequests = message => {
        return /too many recent signup requests/.test(message);
    };

    function formatFeedbackMessage(message) {
        if (isAlreadySubscribed(message)) {
            return 'Given email is already subscribed to the Silvair newsletter.';
        }

        if (hasTooManySignupRequests(message)) {
            return 'You have too many recent signup requests.';
        }

        if (message[0] === '0') {
            return message.substr(3);
        }

        return message;
    }

    const showFeedbackBox = (alertClass, message, subscribeSuccess) => {
        isAlreadySubscribed(message) && $resourceLink.length
            ? showResourceLink()
            : feedbackBox
                  .attr('class', `alert col-md-10 mx-auto text-center ${alertClass}`)
                  .text(formatFeedbackMessage(message));

        if (subscribeSuccess) {
            hideFormContent();
            feedbackBox.removeClass('col-md-10').addClass('col-md-12 mx-auto');
        }
    };

    const showResourceLink = () => {
        hideFormContent();
        $resourceLink.removeClass('d-none');
    };

    const hideFormContent = () => {
        $(this)
            .find('.input-button-row')
            .hide();
    };

    function getCookie(c_name) {
        if (document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");

            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);

                if (c_end == -1) c_end = document.cookie.length;

                return unescape(document.cookie.substring(c_start,c_end));
            }
        }

        return '';
    }

    $.ajax({
        url: '/newsletter',
        method: 'POST',
        data: $('#mc-embedded-subscribe-form-home-newsletter').serialize(),
        headers: {
            'X-CSRFToken': getCookie('csrftoken')
        },
        success: (data, textStatus, xhr) => {
            if (!data.success && data['error-codes'] && !DEBUG) {
                $('.recaptcha').addClass('error');
                grecaptcha.reset();

                return;
            }

            let alertClass = 'alert-success';
            let subscribeSuccess = true;

            if (xhr.status !== 200) {
                alertClass = 'alert-danger';
                subscribeSuccess = false;
            }

            showFeedbackBox(alertClass, "Thanks for signing up for our newsletter.", subscribeSuccess);

            e.preventDefault();
        },
        error: (error) => {
            if (!DEBUG) {
                $('.recaptcha').addClass('error');

                grecaptcha.reset();
            }
        }
    })
});

$('#get-resource-form').submit(function(e) {
    e.preventDefault();

    $('.recaptcha').removeClass('error');

    if (!reCaptchaChecked && !DEBUG) {
        $('.recaptcha').addClass('error');

        return;
    }

    const feedbackBox = $(this).find('.alert');
    const $resourceLink = $('.resource-link');

    const isAlreadySubscribed = message => {
        return /is already subscribed/.test(message);
    };

    const hasTooManySignupRequests = message => {
        return /too many recent signup requests/.test(message);
    };

    function formatFeedbackMessage(message) {
        if (isAlreadySubscribed(message)) {
            return 'Given email is already subscribed to the Silvair newsletter.';
        }

        if (hasTooManySignupRequests(message)) {
            return 'You have too many recent signup requests.';
        }

        if (message[0] === '0') {
            return message.substr(3);
        }

        return message;
    }

    const showFeedbackBox = (alertClass, message, subscribeSuccess) => {
        if (subscribeSuccess) {
            showResourceLink();
            feedbackBox.removeClass('col-md-10').addClass('col-md-12 mx-auto');
        }
    };

    const showResourceLink = () => {
        hideFormContent();
        $resourceLink.removeClass('d-none');
    };

    const hideFormContent = () => {
        $(this)
            .find('.input-button-row')
            .hide();
    };

    function getCookie(c_name) {
        if (document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");

            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);

                if (c_end == -1) c_end = document.cookie.length;

                return unescape(document.cookie.substring(c_start,c_end));
            }
        }

        return '';
    }

    var form = $('#get-resource-form');
    var formData = form.serializeArray().reduce(function(obj, item) {
        obj[item.name] = item.value;
        return obj;
    }, {});

    var data = {
        hubspotFormId: form.attr('data-hubspot-form-id'),
    };

    $.extend(data, formData);

    $.ajax({
        url: '/get-resource',
        method: 'POST',
        data,
        headers: {
            'X-CSRFToken': getCookie('csrftoken')
        },
        success: (data, textStatus, xhr) => {
            if (!data.success && data['error-codes'] && !DEBUG) {
                $('.recaptcha').addClass('error');
                grecaptcha.reset();

                return;
            }

            let alertClass = 'alert-success';
            let subscribeSuccess = true;

            if (xhr.status !== 200) {
                alertClass = 'alert-danger';
                subscribeSuccess = false;
            }

            showFeedbackBox(alertClass, "Thanks for visiting us again!", subscribeSuccess);
            $('.resource-link div').append(data.inlineMessage);
            $('.recaptcha').addClass('d-none');

            document.getElementsByClassName('form-wrapper')[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });

            e.preventDefault();
        },
        error: (error) => {
            if (!DEBUG) {
                $('.recaptcha').addClass('error');

                grecaptcha.reset();
            }
        }
    })
});

$(function handleSliderHeight() {
    $(window).on('resize', setSliderHeight);
});

$(function handleVideoModal() {
    const $videoModal = $('#videoModal');
    const $video = $('#video');

    let $videoSrc;

    $('.video-btn').click(function() {
        $videoSrc = $(this).data('src');
    });

    $videoModal.on('shown.bs.modal', function(e) {
        $video.attr('src', $videoSrc + '?rel=0&showinfo=0&autoplay=1');
    });

    $videoModal.on('hide.bs.modal', function(e) {
        $video.attr('src', $videoSrc);
    });
});

$(function handleBlogArichves() {
    const blogArchiveList = $('.blog-archive > li > a');

    $.each(blogArchiveList, function(index, anchor) {
        if (anchor.pathname === location.pathname) {
            $(anchor).addClass('active');
        }
    });
});

$(function handleFaqAnswerVisibility() {
    const faqItems = $('.faq');

    function toggleFaqAnswerVisibility() {
        const answer = $(this).find('p');

        answer.slideToggle(300);
    }

    $.each(faqItems, function(index, item) {
        item.addEventListener('click', toggleFaqAnswerVisibility);
    });
});

$(function handleExpandAllSectionFaqAnswers() {
    const categories = $('.category');

    function toggleExpandAll() {
        const answersList = $(this)
            .parents()
            .closest('.section-faq-category')
            .find('.faq');

        const anchor = $(this)[0];

        function repalceExpandingAnchorText(searchValue, newValue) {
            anchor.innerText = anchor.innerText.toUpperCase().replace(searchValue, newValue);
        }

        if ($(this).hasClass('expanded')) {
            $.each(answersList, function(index, answer) {
                $(answer)
                    .find('p')
                    .slideUp(300);
            });

            repalceExpandingAnchorText('COLLAPSE', 'EXPAND');
        } else {
            $.each(answersList, function(index, answer) {
                $(answer)
                    .find('p')
                    .slideDown(300);
            });

            repalceExpandingAnchorText('EXPAND', 'COLLAPSE');
        }

        $(this).toggleClass('expanded');
    }

    $.each(categories, function(index, category) {
        const anchor = $(category).find('p');

        anchor.click(toggleExpandAll);
    });
});

$(function handleCollapsingList() {
    const collapsingItemsList = $('.collapsing-list .collapsing-item');

    function toggleCollapse(item) {
        const toggledItem = $(item);

        toggledItem.find('.container').slideToggle(300, () => toggledItem.toggleClass('collapsed'));
    }

    $.each(collapsingItemsList, function(index, collapsingItem) {
        const anchor = $(collapsingItem).find('.collapsing-header');

        anchor.click(() => toggleCollapse(collapsingItem));
    });
});

$(function handleTopSubmenu() {
    const $submenu = $('.submenu-top');
    const $navbar = $('.navbar');
    const $submenuContainer = $('.submenu-container');
    const $submenuList = $submenu.find('ul');
    const $linksList = $submenuList.find('a');
    const $anchorsList = $submenu.find('a[href*="#"]');
    const submenuListHeight = $submenuList.outerHeight();
    const navbarHeight = $navbar.outerHeight();
    const $linkedSections = $(
        $('.section-default > .spacer[id]')
            .get()
            .reverse(),
    );
    const sectionIdToNavigationLink = {};
    const nav = $('.navbar-holder');

    $submenu.css('height', navbarHeight + submenuListHeight);
    $submenuList.css('margin-top', navbarHeight);
    $submenuContainer.css('height', submenuListHeight);

    $submenu.toggle('slide', { direction: 'up' }, 400, () => {
        resizeSubmenu();
    });

    function resizeSubmenu() {
        const submenuListHeight = $submenuList.outerHeight();
        const navbarHeight = $navbar.outerHeight();

        $submenuContainer.css('height', submenuListHeight);
        $submenuList.css('margin-top', navbarHeight);
        $submenu.css({
            height: navbarHeight + submenuListHeight,
            top: $('.navbar-holder').hasClass('slideUp') ? -navbarHeight : 0,
        });
    }

    function handleSubmenuLinkClick(link) {
        const currentNavbarHeight = $navbar.outerHeight();
        const currentSubmenuContainerHeight = $submenuList.outerHeight();
        const linkOffsetTop = link.hash ? $(link.hash).offset().top : 0;
        const anchorPosition = linkOffsetTop - currentSubmenuContainerHeight;

        $('html, body').animate({
            scrollTop: anchorPosition < $(window).scrollTop() ? anchorPosition - currentNavbarHeight : anchorPosition,
        });
    }

    function highlightSubmenuItem() {
        const additionalOffset = 3;
        const scrollPosition = $(window).scrollTop();
        const menuOffset = $submenu.outerHeight() - parseInt($submenu.css('margin-top')) + additionalOffset;

        $.each($linkedSections, (_index, section) => {
            const currentSection = $(section);
            const sectionTop = currentSection.offset().top - menuOffset;

            if (scrollPosition >= sectionTop) {
                const id = currentSection.attr('id');
                const $submenuLink = sectionIdToNavigationLink[id];

                if (!$submenuLink.hasClass('active')) {
                    $anchorsList.removeClass('active');
                    $submenuLink.addClass('active');
                }
                return false;
            }
        });
    }

    $.each($linksList, (_index, link) => {
        link.href === window.location.href && $(link).addClass('active');
        link.hash &&
            $(link).click(e => {
                e.preventDefault();

                handleSubmenuLinkClick(link);
            });
    });

    $.each($linkedSections, (_index, section) => {
        const id = $(section).attr('id');

        sectionIdToNavigationLink[id] = $(`.submenu-top a[href*="#${id}"]`);
    });

    $('.navbar-toggler').click(e => {
        const transitionNormal = 300;

        setTimeout(() => {
            resizeSubmenu();
        }, transitionNormal);
    });

    $(window).resize(resizeSubmenu);
    $(document).on('load scroll mousemove', resizeSubmenu);
    $(document).on('scroll', highlightSubmenuItem);
    $(nav).on('navChanged', resizeSubmenu);
});

$(function handleImportantInfoModal() {
    const $modalInfo = $('#modalImportantInfo');
    const isAceptted = sessionStorage.getItem('infoAceptted');

    $modalInfo.modal({
        backdrop: 'static',
        keyboard: false,
        show: !isAceptted,
    });

    $modalInfo.find('.modal-footer > button').click(() => {
        sessionStorage.setItem('infoAceptted', true);
        $modalInfo.modal('hide');
    });
});

$(function handleInputOptionalInfo() {
    const $notRequiredTextInputWrapper = $('.field-wrapper[class*="textinput"]:not(.required)');
    const $textInput = $notRequiredTextInputWrapper.find('input');
    const $optionalText = $notRequiredTextInputWrapper.find('span');

    $textInput.on('input', e => {
        e.target.value ? $optionalText.fadeOut() : $optionalText.fadeIn();
    });
});

$(function handleHomePageSlideNavbar() {
    const $euBar = $('.eu-bar');
    const $navbar = $('.navbar-container-home').find('.navbar-holder');

    function setNavbarTopPosition() {
        if ($euBar.length) {
            const euBarBottom = $euBar.offset().top + $euBar.height();
            const scrollTop = $(window).scrollTop();
            const euBarVisiblePart = euBarBottom - scrollTop;
            const isEuBarVisible = euBarVisiblePart > 0;

            $navbar.css('top', isEuBarVisible ? euBarVisiblePart : 0);
        }
    }

    $(window).on('scroll load click', setNavbarTopPosition);
});

$(function createCookiesConsent() {
    const cookieConsentStatusDeny = 'deny';
    const cookieBarData = handleLanguageTextVersion();

    const cookieConsent = new cookieconsent.Popup({
        enabled: true,
        revokable: false,
        revokeBtn: '<div></div>',

        status: {
            deny: cookieConsentStatusDeny,
        },

        content: {
            allow: cookieBarData.allow,
            deny: cookieBarData.deny,
            link: '',
            message: `<div class="cc-message-img">\
                    <img src="/static/img/cookie.png" />\
                </div>\
                <div class="cc-message-text">\
                   ${cookieBarData.mainText}
                </div>`,
        },

        type: 'opt-out',

        onStatusChange: function(status, chosenBefore) {
            var type = this.options.type;
            var didConsent = this.hasConsented();
            if (type == 'opt-out' && !didConsent) {
                location.href = cookieBarData.url;
            }
        },
    });

    if (cookieConsent.getStatus() === cookieConsentStatusDeny) {
        cookieConsent.open();
    }

    function handleLanguageTextVersion() {
        const isPLVersion = location.href.includes('/pl/');
        const enData = {
            mainText:
                'This website uses anonymous cookies and third-party services to function properly. To continue your \
                experience with Silvair, you must consent to our Privacy Policy.',
            url: '/doc/privacy-policy/',
            allow: 'Agree and Close',
            deny: 'Read Privacy Policy',
        };

        const plData = {
            mainText:
                'W ramach swoich usług nasza strona gromadzi dane za pośrednictwem technologii takich jak pliki cookies. \
                Aby kontynuować, potwierdź, że zgadzasz się z naszą Polityką Prywatności.',
            url: '/pl/doc/polityka-prywatnosci/',
            allow: 'Akceptuję i zamykam',
            deny: 'Polityka Prywatności',
        };

        return isPLVersion ? plData : enData;
    }
});

$(function handlePhoneCheckbox() {
    const $form = $('.forms');
    const $phoneInput = $form.find('#phone');
    const $phoneAgreeCheckbox = $form.find('#help-text-phone_agree span');
    const $phoneAgreeInput = $form.find('#help-text-phone_agree input');
    const $submitButton = $form.find('button[type="submit"]');

    function setErrorClass(element, isError) {
        isError ? element.addClass('error') : element.removeClass('error');
    }

    function disableSubmitButton(isError) {
        $submitButton[0].disabled = isError;
    }

    $phoneInput.on('blur keyup', () => {
        const isError = $phoneInput[0].value && !$phoneAgreeInput[0].checked;

        setErrorClass($phoneAgreeCheckbox, isError);
        disableSubmitButton(isError);
    });

    $phoneAgreeInput.on('change', e => {
        const isError = !e.target.checked && $phoneInput[0].value;

        setErrorClass($phoneAgreeCheckbox, isError);
        disableSubmitButton(isError);
    });
});

$(function hideFooterEmptyParagraphs() {
    $('.footer-top .menu .col-sm-6.col-md-3 > p').each((index, p) => {
        if (p.innerHTML !== '&nbsp;') {
            return;
        }

        $(p).remove();
    });
});

$(function makeHoverColumnClickable() {
    $('.hover-column').each((index, column) => {
        const $column = $(column);
        const $textContainer = $column.find('> .text-container')

        if (!$textContainer) {
            return;
        }

        const $btn = $textContainer.find('a.btn');
        const url = $btn.attr('href');

        if (!$btn) {
            return;
        }

        $btn.replaceWith(() => {
            return $('<span>').attr('class', $btn.attr('class')).append($btn.contents());
        });

        $column.html($('<a>').attr('href', url).append($column.contents()));
    });
});

$(function handleFAQsearch() {
    const resultsNumberToMakeQuestionsAutomaticallyExpanded = 3;

    if (!$('#faq-search').length) {
        return;
    }

    const $items = $('.collapsing-item');
    const max = $items.length;

    $('#search-value-max').html(max);

    $('#faq-search').on('input', (e) => {
        let found = max;
        const value = e.target.value.trim();

        if (!value) {
            $('#faq-no-results').removeClass('active');
            $('.search-results').addClass('hidden');

            $('.collapsing-list').each((i, list) => {
                $(list).closest('.section-default').removeClass('filtered');
            });

            $items.each((i, item) => {
                $(item).removeClass('filtered').addClass('collapsed');
                $(item).find('> .container').removeAttr('style');
            });

            return;
        }

        $('#faq-no-results').removeClass('active');
        $('.search-results').removeClass('hidden');

        $('.collapsing-list').each((i, list) => {
            $(list).closest('.section-default').removeClass('filtered');
        });

        $items.each((i, item) => {
            const text = $(item).text().toLowerCase();
            const phrases = value.split(' ');

            $(item).removeClass('filtered').addClass('collapsed');
            $(item).find('> .container').removeAttr('style');

            for (const phrase of phrases) {
                if (!phrase) {
                    continue;
                }

                if (text.indexOf(phrase.trim().toLowerCase()) === -1) {
                    $(item).addClass('filtered')

                    found--;

                    return;
                }
            }
        });

        $('#search-value-found').html(found);

        $('.collapsing-list').each((i, list) => {
            if ($(list).find('> .collapsing-item').length === $(list).find('> .collapsing-item.filtered').length) {
                $(list).closest('.section-default').addClass('filtered');
            }
        });

        if (!found) {
            $('#faq-no-results').addClass('active');

            return;
        }

        if (found > resultsNumberToMakeQuestionsAutomaticallyExpanded) {
            return;
        }

        $('.collapsing-item:not(.filtered)').each((i, item) => {
            $(item).removeClass('collapsed');
            $(item).find('> .container').attr('style', 'display: block');
        })
    });

    $('#faq-search-reset').on('click', (e) => {
        $('#faq-search').val('').trigger('input');
    });
});

const video = document.querySelector('.video');
const juice = document.querySelector('.progress-juice');
const progress = document.querySelector('.progress-bar');
const btn = document.getElementById('play-pause');
const fullScreenbtn = document.getElementById('fullscreen');
const fullScreenExitbtn = document.getElementById('exitFullscreen');
const overlay = document.querySelector('.overlay');
const videoControls = document.querySelector('.video-controls');
const videoContainers = document.querySelector('.c-video');
const video_player = document.querySelector('#video_player_box');
const playCircle = document.getElementById('play-circle');
const overlayHeader = document.querySelector('.overlay-header');
const overlayContent = document.querySelector('.overlay-content');
const screenWidth = screen.width;
const modalCloseBtn = document.querySelector('.modalClose');
const playPauseButtons = document.querySelector('.buttons');
const fullscreenButtons = document.querySelector('.fullscreen-buttons');
const customVideoSource = document.querySelector('.custom-source');
const videoSourceText = document.querySelector('.video-source-text');

if (videoSourceText) {
    const videoSrc = videoSourceText.textContent;
    customVideoSource && customVideoSource.setAttribute('src', videoSrc);
    video.load();
}

if (playPauseButtons && playPauseButtons.classList.contains('small-padding')) {
    playPauseButtons.style.padding = '12px 21px 10px 28px';
}

if (fullscreenButtons && fullscreenButtons.classList.contains('small-padding')) {
    fullscreenButtons.style.padding = '12px 28px 10px 21px';
}

function togglePlayPause() {
    if (video.paused) {
        btn.classList.remove('play');
        btn.classList.add('pause');
        overlay.style.display = 'none';
        video.play();
    } else {
        btn.classList.remove('pause');
        btn.classList.add('play');
        overlay.style.display = 'flex';
        video.pause();
    }
}

function toggleFullscreen() {
    if (video_player.requestFullScreen) {
        fullScreenbtn.classList.remove('fullscreen');
        fullScreenbtn.classList.add('exitFullscreen');
        video_player.requestFullScreen();
    } else if (video_player.webkitRequestFullScreen) {
        fullScreenbtn.classList.remove('fullscreen');
        fullScreenbtn.classList.add('exitFullscreen');
        video_player.webkitRequestFullScreen();
    } else if (video_player.mozRequestFullScreen) {
        fullScreenbtn.classList.remove('fullscreen');
        fullScreenbtn.classList.add('exitFullscreen');
        video_player.mozRequestFullScreen();
    }
}

function handleExitFullscreen() {
    if (document.exitFullscreen) {
        fullScreenbtn.classList.remove('exitFullscreen');
        fullScreenbtn.classList.add('fullscreen');
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
        fullScreenbtn.classList.remove('exitFullscreen');
        fullScreenbtn.classList.add('fullscreen');
        document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
        fullScreenbtn.classList.remove('exitFullscreen');
        fullScreenbtn.classList.add('fullscreen');
        document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
        fullScreenbtn.classList.remove('exitFullscreen');
        fullScreenbtn.classList.add('fullscreen');
        document.msExitFullscreen();
    }
}

function scrub(e) {
    const scrubTime = (e.offsetX / progress.offsetWidth) * video.duration;
    video.currentTime = scrubTime;
}

if (playCircle) {
    playCircle.onclick = function() {
        togglePlayPause();
    };
}

if (video) {
    video.onclick = function() {
        togglePlayPause();
    };
}

if (btn) {
    btn.onclick = function() {
        togglePlayPause();
    };
}

if (modalCloseBtn) {
    modalCloseBtn.onclick = function() {
        btn.classList.remove('pause');
        btn.classList.add('play');
        video.pause();
    };
}

if (overlay) {
    overlay.onclick = function() {
        videoControls.style.display = 'flex';
    };
}

if (fullScreenbtn) {
    fullScreenbtn.onclick = function() {
        if (this.classList.contains('exitFullscreen')) {
            handleExitFullscreen();
        } else {
            toggleFullscreen();
        }
    };
}

if (video) {
    video.addEventListener('timeupdate', function() {
        var juicePos = video.currentTime / video.duration;
        juice.style.width = juicePos * 100 + '%';
        if (video.ended) {
            btn.classList.remove('pause');
            btn.classList.add('play');
        }
    });
}

if (progress) {
    progress.addEventListener('click', scrub);
}

if (videoContainers && overlay && videoContainers.classList.contains('with-overlay')) {
    overlay.style.display = 'flex';
    videoControls.style.display = 'none';
} else if (overlay) {
    overlay.style.display = 'none';
}

if (overlay && overlay.classList.contains('with-content')) {
    overlayHeader.style.display = 'flex';
    overlayContent.style.display = 'flex';
} else if (overlayContent) {
    overlayContent.style.display = 'none';
}

function text_truncate(str, length, ending) {
    if (length == null) {
        length = 100;
    }
    if (ending == null) {
        ending = '...';
    }
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    } else {
        return str;
    }
}

if (screenWidth < 550) {
    overlayContent.innerText = text_truncate(`${overlayContent.innerText}`);
}



// WEBPACK FOOTER //
// ./js/main.js